import React from "react";
import classNames from "classnames";
import { Button } from "@blueprintjs/core";
import TextTruncate from "components/TextTruncate";
import ChevronDown from "icons/chevron_down.svg";
import * as styles from "./styles.module.scss";
const DefaultSelectButton = ({ value, placeholder, className, onKeyDown, onBlur, customChevron, prefix, viewMode = false, testId, }) => (React.createElement(Button, { minimal: true, onKeyDown: onKeyDown, onBlur: onBlur, className: classNames(styles.root, className), "data-testid": testId },
    prefix,
    React.createElement(TextTruncate, { className: classNames(styles.label, {
            [styles.placeholder]: !value && !!placeholder,
            [styles.viewMode]: viewMode,
        }), text: value || placeholder }),
    (!viewMode && customChevron) ?? React.createElement(ChevronDown, null)));
export default DefaultSelectButton;
